import { useAppSelector } from '~/app/hooks'
import { isDarkTheme } from '~/redux/features'

export function EFDuplicateIcon() {
  const isDark = useAppSelector(isDarkTheme)
  const fill = isDark ? 'var(--color-dark-theme)' : '#666666'
  return (
    <svg
      width='20'
      height='23'
      viewBox='0 0 20 23'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14.499 0.5H2.49902C1.39902 0.5 0.499023 1.4 0.499023 2.5V16.5H2.49902V2.5H14.499V0.5ZM17.499 4.5H6.49902C5.39902 4.5 4.49902 5.4 4.49902 6.5V20.5C4.49902 21.6 5.39902 22.5 6.49902 22.5H17.499C18.599 22.5 19.499 21.6 19.499 20.5V6.5C19.499 5.4 18.599 4.5 17.499 4.5ZM17.499 20.5H6.49902V6.5H17.499V20.5Z'
        fill={fill}
      />
      <path
        d='M11.9966 9.5L11.9966 16.5'
        stroke={fill}
      />
      <path
        d='M15.499 13H8.49902'
        stroke={fill}
      />
    </svg>
  )
}
